import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  current: {},
  versions: [],
  loading: false
};

const vdnSettingsSlice = createSlice({
  name: 'vdnSettings',
  initialState,
  reducers: {
    vdnSettingsRequest: {
      reducer(state) {
        state.loading = true;
      }
    },
    vdnSettingsFailure: {
      reducer(state) {
        state.loading = false;
      }
    },
    getVdnSettingsSuccess: {
      reducer(state, action) {
        state.current = { ...action.payload };
        state.loading = false;
      }
    },
    updateVdnSettingsSuccess: {
      reducer(state, action) {
        state.current = { ...action.payload };
        state.loading = false;
      }
    },
    getVdnVersionsSuccess: {
      reducer(state, action) {
        state.versions = [...action.payload];
        state.loading = false;
      }
    },
    resetVdnSettings: {
      reducer(state) {
        state.current = {};
        state.versions = [];
      }
    }
  }
});

export const {
  vdnSettingsRequest,
  vdnSettingsFailure,
  getVdnSettingsSuccess,
  updateVdnSettingsSuccess,
  getVdnVersionsSuccess,
  resetVdnSettings
} = vdnSettingsSlice.actions;

export default vdnSettingsSlice.reducer;
